export default __webpack_public_path__ + "static/media/item4.cecea4b6.png";